module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_9505_light_grey.04121336.jpg";